import React from 'react';
import { Switch } from 'react-router-dom';
import defaultProps from 'recompose/defaultProps.js';
import { Route, NotFound } from 'cccisd-laravel-boilerplate';
import { AdminRoutes, Dashboard as AppdefDashboard, Manage as AppdefManage } from 'cccisd-laravel-appdefs';
import { AuthRedirect } from 'cccisd-laravel-nexus';
import { Quest } from 'cccisd-laravel-assignment';

// Layouts
import MainLayout from './layouts/MainLayout';
import RocketShipLayout from './layouts/RocketShipLayout';

// Pages
/* eslint-disable import/no-extraneous-dependencies, import/no-unresolved */
import Welcome from './pages/Welcome'; // Include it into main bundle
import QuestAdminHome from './pages/QuestAdminHome'; // Include it into main bundle
import RocketShip from './pages/RocketShip'; // Include it into main bundle
import Products from './pages/Products';

// Laravel packages
import Nexus from 'bundle-loader?lazy!cccisd-laravel-nexus';

// Bind MainLayoutFluid by default
const MainLayoutNoSecondaryNav = defaultProps({
    className: 'container-fluid',
    showSecondaryNav: false,
})(MainLayout);
const MainLayoutFluid = defaultProps({ className: 'container-fluid' })(MainLayout);
const QuestLayout = defaultProps({
    className: '',
    showPrimaryNav: false,
    showSecondaryNav: false,
    showFooter: false,
})(MainLayout);
const AppRoute = defaultProps({ layout: MainLayoutFluid })(Route);

let Fortress = window.cccisd.fortress;
let AppDefinitions = window.cccisd.appDefs;

const match = {
    AppdefDashboard,
    AppdefManage,
    QuestAdminHome,
    Welcome,
    Products,
};

const layoutMatch = {
    MainLayout,
    MainLayoutFluid,
    MainLayoutNoSecondaryNav,
    QuestLayout,
};

export default () => (
    <Switch>
        {AppDefinitions.routes.map(route => {
            const Component = match[route.componentHandle];
            if (!Component) {
                return null;
            }

            return (
                <AppRoute
                    key={route.handle}
                    path={route.url}
                    component={Component}
                    componentProps={route.componentProps}
                    exact
                    layout={'layout' in route ? layoutMatch[route.layout] : MainLayoutFluid}
                />
            );
        })}

        <AppRoute path="/" component={Welcome} exact layout={MainLayout} />
        <AppRoute path="/rocketship/:studyString?" component={RocketShip} exact layout={RocketShipLayout} />

        <AppRoute path="/products" component={Products} />

        <AppRoute path={['/quest/preview', '/d', '/survey']} component={Quest} layout={null} />

        {AdminRoutes(MainLayoutNoSecondaryNav)}

        <AppRoute path="/account" component={Nexus} />

        <AppRoute path={Fortress.settings.config.after_login_url} component={AuthRedirect} exact />

        {/* Not found page */}
        <AppRoute component={NotFound} layout={MainLayout} />
    </Switch>
);
